import React from "react";
import "./PressItem.css";
import { Card } from "@tennr/frontend/components/Card";

type PressItemProps = {
  title: string;
  cta: string;
  image?: string;
  date?: string;
};

export const PressItem: React.FC<PressItemProps> = (props) => {
  return (
    <Card className={`press-item ${props.type == 'release' ? ' press-release' : 'article'}`}>
      <a href={ props.url } target="_blank">
        { props.image && (<div className="img-wrap"><img src={ props.image } alt={props.title} /></div>)}        
        <span className="item-date">{props.date}</span>        
        <h4>{props.title}</h4>            
        <span className={`item-cta ${props.type != 'release' ? 'alt' : ''}`}>{props.cta}</span>        
      </a>
    </Card>
  );
};
